import { render, staticRenderFns } from "./natResourceAddPermission.vue?vue&type=template&id=63ffdc48&scoped=true&"
import script from "./natResourceAddPermission.vue?vue&type=script&lang=js&"
export * from "./natResourceAddPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ffdc48",
  null
  
)

export default component.exports